import Login from './Login';
import OidcCallbackHandler from './OidcCallbackHandler';
import { authRoles } from 'app/auth';

export const LoginConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: authRoles.onlyGuest,
	routes: [
		{
			path: '/login/:userKey?',
			component: Login
		},
		{
			path: '/openId',
			component: OidcCallbackHandler
		}
	]
};
